module.exports = MaterialUI.CircularProgress;